import type { IconProps } from '../types/IconProps.ts';
export const ImageMinus: IconProps = {
    name: 'ImageMinus',
    children: [
        `<path d="M11 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2v-8" />`,
        `<path d="m6 21 8.13-8.13a2 2 0 0 1 2.04-.48L21 14M9 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4M16 5h6" />`,
    ]
};